import { CalendarProvider } from "../../../components/business/calendar/calendarContext.js"; 
import KeteroCalendarController from "../../../components/business/calendar/keteroCalendarController.js";
import Portal from "../portal";

const Calendar = (props) => {
  return (
    <CalendarProvider myBookingTypes={props.myBookingTypes}>
      <Portal TabComponent={KeteroCalendarController} props= {props}/>
    </CalendarProvider>
  );
};
export default Calendar;
